<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Reports</translate></template>
        </TitleBar>
        <div class="content">
            <dl>
                <h3><translate>Basic</translate></h3>

                <router-link :to="{name: 'RevenueExpenses'}" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-bar-chart" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Revenue and expenses</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Revenue, expenses and margins of your company period time</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <router-link :to="{name: 'HoursReport'}" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-clock" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Hours</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Full report of all hours in your system</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <h3><translate>Premium</translate></h3>
                
                <router-link :to="{name: 'BalanceSheet'}" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-euro" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Balance Sheet Investments</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Overview of all Balance Sheet costs and other assets and their write off periods</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <router-link :to="{name: 'FinancialStatements'}" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-balance-scale" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Financial Statements</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Yearly financial Profit & Loss and Balance Sheet statements for tax and reporting purposes</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <router-link v-if="currentCompany.country === 'BE'" :to="{name: 'VATReportBEList'}" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-database" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Belgian VAT (Beta)</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Automatic value-added tax report for the Belgian tax office based on your company's information</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <router-link v-if="currentCompany.country === 'NL' || currentCompany.country === 'BE'" :to="{name: 'TaxreportList'}" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-database" />
                        </div>
                        <div>
                            <dt v-if="currentCompany.country === 'NL'" class="report-title">
                                <translate>VAT</translate>
                            </dt>
                            <dt v-if="currentCompany.country === 'BE'" class="report-title">
                                <translate>VAT (Dutch Belastingdienst)</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Automatic value added tax report based on your company data</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

<!--                <a v-if="currentCompany.country !== 'ES'" :href="`${Urls['reports:home']()}#/list/${getCompanyId}/`" class="report-link">-->
<!--                    <div class="report-list-element">-->
<!--                        <div class="icon-container">-->
<!--                            <font-awesome-icon icon="fa-solid fa-database" />-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <dt v-if="currentCompany.country === 'NL'" class="report-title">-->
<!--                                <translate>VAT</translate>-->
<!--                            </dt>-->
<!--                            <dt v-if="currentCompany.country === 'BE'" class="report-title">-->
<!--                                <translate>VAT (Dutch Belastingdienst)</translate>-->
<!--                            </dt>-->
<!--                            <dd class="description-container">-->
<!--                                <translate>Automatic value added tax report based on your company data</translate>-->
<!--                            </dd>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </a>-->

                <!--<router-link :to="{ name: 'ForeignVATList' }" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-passport" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Foreign VAT</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>VAT charged in other countries</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>-->

                <router-link :to="{ name: 'Products' }" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-line-chart" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Products and services</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Quantity and revenue of products and services you often invoice</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <router-link :to="{ name: 'CustomerInsight' }" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-heart" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Customer insight</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Trips, hours and profit & loss for each customer side-by-side</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <router-link :to="{ name: 'SupplierInsight' }" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-cart-shopping" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Supplier insight</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Expenses made per supplier</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <router-link :to="{ name: 'CostCategories' }" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-pie-chart" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Cost categories</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Expenses report by cost category</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <router-link :to="{ name: 'CashFlow' }" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-area-chart" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Cash Flow</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Explore the evolution of your cash flow</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>

                <router-link v-if="currentCompany.country === 'NL'" :to="{ name: 'ForeignVATList' }" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-globe-europe" />
                        </div>
                        <div>
                            <dt class="report-title">
                                <translate>Foreign VAT</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Tax report for foreign VAT charged via OSS</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>
                
                <router-link v-if="currentCompany.country === 'NL' || currentCompany.country === 'BE'" :to="{ name: 'EUServicesList' }" class="report-link">
                    <div class="report-list-element">
                        <div class="icon-container">
                            <font-awesome-icon icon="fa-solid fa-globe" />
                        </div>
                        <div>
                            <dt v-if="currentCompany.country === 'NL'" class="report-title">
                                <translate>Intracommunautaire Prestaties</translate>
                            </dt>
                            <dt v-if="currentCompany.country === 'BE'" class="report-title">
                                <translate>Intracommunautaire Prestaties (Dutch Belastingdienst)</translate>
                            </dt>
                            <dd class="description-container">
                                <translate>Belastingdienst tax report for exports within the EU with reverse charged VAT</translate>
                            </dd>
                        </div>
                    </div>
                </router-link>
            </dl>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import TitleBar from "@/components/TitleBar";

export default {
    name: 'Reports',
    components: {TitleBar},
    computed: {
        ...mapGetters({ 
            getCompanyId: 'main/getCompanyId',
            currentCompany: "main/getCurrentCompany",
        }),
        currentYear() {
            const date = new Date();
            return date.getFullYear();
        }
    }
}
</script>

<style lang="scss" scoped>
.report-link:hover {
    text-decoration: none;
}

.report-title {
    color: $colorTextBase;
}

.icon-container {
    padding-right: 12px;
    padding-left: 12px;
    align-self: center;
    color: $colorBrand;
    font-size: 30px;
    min-width: 62px;
    text-align: center;
}

.description-container {
    color: $colorTextSemi;
    font-size: 12px;
}

.report-list-element {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
}

.report-list-element:hover {
    background-color: #eeeeee;

    .report-title {
        color: $colorBrand !important;
    }
}
</style>